import { useConnect } from '@lore/query-connect';
import { project_networkId, event_networkId } from '@/utils/query-helpers';

// scope through the parent project/event; the evaluation's own networkId is not always set
const NETWORK_FILTERS = {
  project: project_networkId,
  event: event_networkId
};

export default function createEvaluationsHook(model, entityKey, { completed = false } = {}) {
  return function useEvaluations({ network, state, schoolStart, schoolEnd } = {}) {
    return useConnect(`${model}.find`, {
      where: {
        eager: {
          $where: {
            ...(completed ? { completed: true } : {}),
            ...(state ? {
              [entityKey]: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              }
            } : NETWORK_FILTERS[entityKey](network)),
            createdAt: {
              $lte: schoolEnd,
              $gte: schoolStart
            }
          }
        }
      },
      pagination: {
        pageSize: 1
      }
    });
  };
}
